import { useTopic } from "../hooks/use-topics";

export const VersionCounter = () => {
  const { versionIndex, setVersionIndex, versionsCount } = useTopic();

  return (
    <>
      {versionIndex > 0 && (
        <span
          className="doc-nav"
          onClick={() => setVersionIndex((prev) => prev - 1)}
        >
          &lt;
        </span>
      )}
      {versionsCount > 1 && (
        <span>
          {versionIndex + 1}/{versionsCount}
        </span>
      )}
      {versionIndex < versionsCount - 1 && (
        <span
          className="doc-nav"
          onClick={() => setVersionIndex((prev) => prev + 1)}
        >
          &gt;
        </span>
      )}
    </>
  );
};
